import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog3D() {
  const [loading, setLoading] = useState(false);
   const [showSuccessModal, setShowSuccessModal] = useState(false);
        const [formType, setFormType] = useState(""); // stores which button opened the form
    const [contactForm, setContactForm] = useState({
      fullname: "",
      company: "",
      website: "",
      email: "",
      phone: "",
      message: "",
    });
    const handleContactChange = (e) => {
      const { name, value } = e.target;
      setContactForm((prev) => ({ ...prev, [name]: value }));
    };
    
    
    const isBusinessEmail = (email) => {
      const freeDomains = [
        "gmail.com",
        "yahoo.com",
        "hotmail.com",
        "outlook.com",
        "aol.com",
        "icloud.com",
        "mail.com",
        "live.com"
      ];
      const domain = email.split("@")[1]?.toLowerCase();
      if (!domain) return false;
      return !freeDomains.includes(domain);
    };
    
    
    const handleContactSubmit = async (e) => {
      e.preventDefault();
     
      setLoading(true); // show loading message
      const { fullname, company, website, email, phone, message} = contactForm;
    
    
      // Basic validation
      if (!fullname || !email || !message || !company || !phone) {
        alert("Please fill all required fields.");
          setLoading(false); // show loading message
    
        return;
      }
    if (!isBusinessEmail(email)) {
        alert("Please enter a business email, not Gmail/Yahoo/etc.");
          setLoading(false); // show loading message
    
        return;
      }
     
    
      try {
          try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
        const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

        });
    
        if (response.ok) {
           setShowSuccessModal(true);  // ✅ This triggers modal to open
           setLoading(false); // show loading message
           setContactForm({
            fullname: "",
            company: "",
            website: "",
            email: "",
            phone: "",
            message: "",
          });
        } else {
          alert("Error sending message.");
        }
      } catch (err) {
        console.error(err);
        alert("Error sending message.");
      }
    };
      
  return (
    <div>
      <Header />
      <main>
            <AnimatePresence>
              {showSuccessModal && (
                <motion.div
                  className="modal-overlay show"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <motion.div
                    className="modal show"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      background: "#fff",
                      padding: "30px",
                      borderRadius: "10px",
                      width: "400px",
                      textAlign: "center",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                    }}
                  >
                    <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                      Message Sent!
                    </h2>
                    <p>Thank you for contacting us. We will get back to you shortly.</p>
                    <button className="vc rg lk gh ml il hi gi _l"
                      onClick={() => setShowSuccessModal(false)}
                     
                    >
                      Close
                    </button>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
            
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
             
              <div className="container">
               <div className="left">
          <img src="../images/blogim3.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
               How Intent Data, AI Automation, and Human Validation Drive Smarter Demand Generation
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span>  Oct 22, 2025
                </li>
                  <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
               <p className="mb bgimh">
          Why Top of Funnel Strategy Is the Backbone of Effective Demand Generation
              </p>

                <p className="jutfy">
                  In the world of B2B marketing, where timing, precision, and personalization determine success, relying on just one method of lead generation is no longer enough. Traditional outbound efforts fall short, and not every inbound lead is sales-ready. So how do you ensure your pipeline is filled with quality leads that are both interested and a good fit?
    </p>
              <p className="mb bgimh">
             The answer lies in a hybrid demand generation approach that combines:
              </p>
              <ul className="jutfy">
                <li>
                  •	Intent Data (to know who’s actively researching solutions)</li>
  <li>•	AI Automation (to scale lead scoring and outreach), and</li>
  <li>•	Human Lead Validation (to add accuracy, context, and trust).

                </li>
              </ul>
              
 <p className="jutfy">
  Together, these three pillars create a powerful framework for not just generating leads — but generating the right leads that move the revenue needle.
 </p>
               <p className="mb bgimh">
             Let’s explore how each part plays a role, and how their integration transforms your demand generation engine.
             <br/>
             What Is Intent Data — and Why Does It Matter?
              </p>
 <p className="jutfy">
  Intent data refers to behavioral signals that indicate a prospect is actively researching a topic, solution, or challenge. It captures the “digital breadcrumbs” left behind when users:
 </p>
              
              <ul className="jutfy">
                <li>•	Visit industry sites</li>
 <li>•	Search for specific keywords</li>
 <li>•	Download related content</li>
 <li>•	Attend webinars</li>
 <li>•	Read product comparisons</li>
              </ul>

                <p className="jutfy">
                  Using this data, you can identify accounts or individuals showing buying intent long before they fill out a form on your website.
              </p>
              <p className="mb bgimh">
            Benefits of Intent Data:
              </p>
              <ul className="jutfy">
                <li>•	Reach prospects before your competitors</li>
 <li>•	Focus resources on accounts that are already in the buying journey</li>
 <li>•	Craft hyper-personalized messaging aligned with real-time interests</li>
 <li>•	Shorten sales cycles with well-timed outreach
</li>
              </ul>

              <p className="jutfy">
                In short, intent data gives you a head start — but it needs support from automation and human insight to deliver scalable results.
              </p>
              
               <p className="mb bgimh">
          AI Automation: Scaling Personalization and Efficiency
              </p>
              <p className="jutfy">
                Once you’ve identified potential leads through intent data, the next step is AI-powered automation — the engine that helps you prioritize, score, and engage leads at scale.
              </p>
                 <p className="mb bgimh">
           Key Areas Where AI Supports Demand Gen:
              </p>
              <p className="jutfy">
                Predictive Lead Scoring: AI evaluates data points like engagement, company size, past behavior, and fit to rank leads by conversion potential.
              </p>
              <ul className="jutfy">
                <li>•	Website traffic from TOFU channels
</li>
<li>•	Automated Outreach: AI tools can send personalized emails, trigger follow-ups, and adjust messaging based on behavioral signals.
</li>
<li>•	Smart Segmentation: Group prospects dynamically based on industry, stage, interest level, and more for tailored campaigns.
</li>
<li>•	AI Chatbots & Virtual Assistants: Handle top-of-funnel interactions and qualification in real time.
</li>
              </ul>
              
               <p className="mb bgimh">
          AI + Intent Data: A Powerful Duo
              </p>
              <p className="jutfy">
                By combining intent data with AI models, you’re not just reacting to signals — you’re predicting who will engage, when, and why. This enables:
              </p>
               <ul className="jutfy">
                <li>•	Smarter campaign timing</li>
 <li>•	More relevant messaging</li>
 <li>•	Higher response rates</li>
 <li>•	Reduced manual workload for your sales team
</li>
               </ul>
             <p className="mb bgimh">
         However, AI still lacks the nuance and judgment that only humans can provide.
         <br/>
         The Human Lead Validation Layer: The Final Filter
              </p>
           
              <p className="jutfy">
Automation can take you far, but human lead validation ensures you’re not chasing ghosts or wasting time on low-quality leads.
<br/>
<br/>
Here’s what humans do best in the lead validation process:
              </p>
              <p className="mb bgimh">
                Contextual Verification
              </p>
               <p className="jutfy">
                Humans can research and verify job titles, buying power, decision-making influence, and engagement signals. For example, AI might tag someone as a VP, but a human can check if they’re actively involved in procurement or just browsing.
               </p>

                <p className="mb bgimh">
                Direct Outreach & Qualification
              </p>
               <p className="jutfy">
Experienced SDRs or lead researchers can pick up the phone or send a personalized message to verify interest and gather valuable insights like
               </p>
               <ul className="jutfy">
                <li>•	Budget and timeline</li>
  <li>•	Specific pain points</li>
  <li>•	Buying committee structure
</li>
               </ul>
                 <p className="mb bgimh">
             Data Accuracy & Hygiene
              </p>
               <p className="jutfy">
                Human validation helps clean inaccurate or outdated data, ensuring that your CRM stays clean and your lead nurturing efforts aren’t wasted.
              </p>

              <p className="mb bgimh">
            Real Impact on Demand Generation
              </p>
               <p className="jutfy">
                By integrating this hybrid approach, marketing and sales teams can expect
              </p>
              <ul className="jutfy">
                <li>•	Higher lead-to-opportunity conversion rates</li>
<li>•	Reduced cost-per-lead (CPL) by focusing on high-intent accounts</li>
<li>•	Shorter sales cycles through timely, relevant outreach</li>
<li>•	Better alignment between marketing and sales</li>
<li>•	Increased ROI on demand gen campaigns</li>
               </ul>
                <p className="jutfy">
              Instead of casting a wide net and hoping for results, you’re using data, automation, and human insight to connect with the right people at the right time with the right message. 
              </p>
              <p className="mb bgimh">
           Final Thoughts: Smarter, Not Just Harder
              </p>
               <p className="jutfy">
               In the modern B2B landscape, volume alone won’t win. Precision, timing, and relevance are everything. By combining intent data, AI automation, and human validation, you’re building a system that doesn’t just generate leads — it generates opportunity.
              </p>
               <p className="mb bgimh">
          Ready to Fuel Your Pipeline with Real Demand?
          <br/>
          <br/>
          Discover how our Intent + AI + Human Validation Model can 10x your demand generation ROI.
              </p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
            <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: How Intent Data, AI Automation, and Human Validation Drive Smarter Demand Generation");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog3D;
